import MUIFormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled, { css } from "styled-components";
import { HXTextField, withExplicitProps } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
export const AdminFormSection = styled(FlexColumnDiv) `
    gap: 16px;
    font-size: ${fontSizes.STANDARD};

    & ${HXTextField} {
        width: ${(props) => { var _a; return (_a = props.textFieldWidth) !== null && _a !== void 0 ? _a : "360px"; }};
    }

    & button {
        align-self: flex-start;
    }
`;
export const AdminFormSectionDescription = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const AdminFormSectionTitle = withExplicitProps(styled.div, "required", "error") `
    font-weight: bold;

    ${(props) => props.required &&
    css `
            &::after {
                content: " *";
                color: ${colors.tulip_main};
            }
        `}

    ${(props) => props.error &&
    css `
            color: ${colors.tulip_main};
        `}
    ${(props) => props.disabled &&
    css `
            color: ${colors.black_lighter};
        `}
`;
export const AdminForm = styled(FlexColumnDiv) `
    gap: 32px;
`;
export const AdminFormHolder = styled(FlexColumnDiv) `
    gap: 32px;
`;
export const AdminFormWithDividersHolder = styled(FlexColumnDiv) `
    gap: 24px;
`;
export const AdminFormDescription = styled(FlexColumnDiv) `
    gap: 8px;
    max-width: 700px;
`;
export const AdminFormProviderIdTextField = styled(HXTextField) `
    margin-left: 42px;
    align-self: stretch;
`;
export const FormControlLabel = styled(MUIFormControlLabel) `
    align-self: stretch;

    .MuiSvgIcon-root {
        width: 24px;
        height: 24px;
    }

    &.MuiFormControlLabel-labelPlacementEnd {
        margin-left: 0; // There's a default -11 left-margin
    }
`;
export const IndentedSection = styled(FlexColumnDiv) `
    padding-left: 42px;
    gap: 8px;
`;
export const IndentedTextfieldSection = styled(IndentedSection) `
    padding-left: 42px;
    gap: 24px;
`;
export const NestedContentRadioGroup = styled(RadioGroup) `
    gap: 40px;
`;
export const RadioIcon = styled(Radio) ``;
